// === Back-stack navigation synced to the History API ===
//
// Goal: the device/browser Back button (and Esc / close buttons / overlay
// clicks) should dismiss the top open overlay (card / search / info modal),
// then return to the Home/start screen — instead of leaving the app.
//
// We keep a tiny LIFO stack of "dismiss" callbacks. Each entry mirrors one
// history entry we pushed. On `popstate` (hardware Back, or our own back()
// call) we pop the top entry and run its dismiss.

const stack = [];

// Push a screen/overlay onto the back-stack with a matching history entry.
// `dismiss` is the RAW close fn (hide the overlay, or show Home) — it must NOT
// itself call history.back()/back(), or it would double-pop.
export function pushScreen(dismiss) {
  stack.push(dismiss);
  history.pushState({ navDepth: stack.length }, '');
}

// True if at least one screen/overlay is on the stack (i.e. not at the root).
export function hasScreens() {
  return stack.length > 0;
}

// Called by UI close affordances (X button, overlay click, Esc, header Home).
// Routed through history.back() so it behaves identically to the device Back
// button: popstate then runs the matching dismiss.
export function back() {
  if (stack.length) history.back();
}

export function initNav() {
  // Establish a clean base entry = the Home/start screen (stack empty).
  history.replaceState({ navDepth: 0 }, '');
  window.addEventListener('popstate', () => {
    const dismiss = stack.pop();
    if (dismiss) dismiss();
    // stack empty → at the root; let the browser handle further Back (exit).
  });
}
